import getConfig from 'next/config';

const {
  ANALYTICS_GTM_ID,
  API_BASE_URL,
  APP_ENV,
  ASSET_PREFIX,
  CUSTOMER_CARE_EMAIL,
  DEFAULT_TIMEZONE_DESCRIPTION,
  DEFAULT_TIMEZONE,
  DEFAULT_LANGUAGE,
  FACEBOOK_PIXEL_ID,
  GOOGLE_API_KEY,
  LANDING_BASE_URL,
  PLATFORM_ID,
  PLATFORM_PREFIX,
  PLATFORM_TYPE,
  PLATFORM,
  TYPEFORM_URL,
  ZIPCODE_LENGTH,
  BEAUTY_GUIDE_LOADER,
  BEAUTY_GUIDE_CHUNK,
  BEAUTY_GUIDE_MAIN_CHUNK,
  BEAUTY_GUIDE_CSS,
  BEAUTY_GUIDE_VERSION,
  HOME_PUBLIC_TITLE,
  HOME_PUBLIC_DESCRIPTION,
  LOGIN_TITLE,
  LOGIN_DESCRIPTION,
  CURRENT_COUNTRY,
  WEBEAT_MEDIA_BUCKET,
} = getConfig().publicRuntimeConfig;

const cookiePlatformPrefix = () => {
  if (APP_ENV === 'production') return '';
  return `_${APP_ENV}`;
};

export const config = {
  API: {
    BASE_URL: API_BASE_URL,
  },
  APP: {
    ENV: APP_ENV,
    GTM_ID: ANALYTICS_GTM_ID,
    FB_ID: FACEBOOK_PIXEL_ID,
    ASSET_PREFIX,
    BASE_URL: PLATFORM_PREFIX,
    CURRENT_COUNTRY,
    DEFAULT_TIMEZONE,
    DEFAULT_TIMEZONE_DESCRIPTION,
    DEFAULT_LANGUAGE,
    NAME: 'Isdin',
    MEDIA_CON:
      'https://s3.eu-west-1.amazonaws.com/media.love.isdin.com/con-es/images/',
    VIDEO_CON:
      'https://s3.eu-west-1.amazonaws.com/media.love.isdin.com/con-es/videos/',
    MARKETING_MATERIALS: {
      DEFAULT_IMAGE_BG: `${ASSET_PREFIX}/material_default_bg.png`,
      DEFAULT_VIDEO_BG: `${ASSET_PREFIX}/material_default_video.png`,
      DEFAULT_FILE_BG: `${ASSET_PREFIX}/material_default_pdf_bg.png`,
      ID_VADEMECUM: 4,
      MAX_ROW_CARDS: 4,
    },
    PLATFORM,
    PLATFORM_TYPE,
    CUSTOMER_CARE_EMAIL,
    SEO: {
      CON: {
        LOGIN_DESCRIPTION: LOGIN_DESCRIPTION,
        LOGIN_TITLE: LOGIN_TITLE,
        HOME_PUBLIC_DESCRIPTION: HOME_PUBLIC_DESCRIPTION,
        HOME_PUBLIC_TITLE: HOME_PUBLIC_TITLE,
      },
    },
    TYPEFORM_URL: TYPEFORM_URL || 'https://isdin.typeform.com/to',
    YOUTUBE_EMBEDDED_URL: 'https://www.youtube.com/embed/',
    GOOGLE_API_KEY,
    CONSUMABLES: {
      IMAGES:
        'https://s3.eu-west-1.amazonaws.com/media.love.isdin.com/con-es/consumables/images/',
      VIDEOS:
        'https://s3.eu-west-1.amazonaws.com/media.love.isdin.com/con-es/consumables/videos/',
    },
    WEBEAT_MEDIA_BUCKET,
    ADYEN_ENVIRONMENT: APP_ENV === 'production' ? 'live' : 'test',
    ADYEN_CLIENT_KEY:
      APP_ENV === 'production'
        ? 'live_WCMUPXQKTBCGFF53KPHJ2VAAZ46CEVXK'
        : 'test_XBAZAKI3YVDT7NUAS46BLFXIXIPUHZ2H',
  },
  BREAKPOINTS: {
    DESKTOP_BG: 1200,
    DESKTOP: 1024,
    TABLET: 768,
    MOBILE: 480,
  },
  REGISTER: {
    ID_LANGUAGE: 1,
    ID_COUNTRY: 1,
    PASSWORD_LENGTH: 6,
    BEHAVIOR: 'Mr',
    DIRECTION_COUNTRY: 'US',
    PLATFORM_ID: PLATFORM_ID || 'liww_usa',
    PRACTICE_TYPE: 'Centro_Medico',
    ZIPCODE_LENGTH: ZIPCODE_LENGTH || 5,
    MIN_REGISTER_DATE: '1900/01/01',
  },
  COOKIES: {
    ACCESS_TOKEN: `loveisdinww_auth${cookiePlatformPrefix()}`,
    BASE_COOKIE_DOMAIN: APP_ENV === 'local' ? 'localhost' : '.isdin.com',
    REFRESH_TOKEN: `loveisdinww_ref_t${cookiePlatformPrefix()}`,
    TOAST_COOKIE: `loveisdinww_toast_points`,
    VALIDATION_COOKIE: `loveisdinww_auth_v${cookiePlatformPrefix()}`,
    ACCESS_TOKEN_COOKIE_EXPIRATION: 60,
    REFRESH_TOKEN_COOKIE_EXPIRATION: 95,
    VALIDATION_COOKIE_EXPIRATION: 0.000347,
    COUNTRY_SELECTED: `country-selected`,
  },
  CON: {
    PAGES: {
      TERMS: '/terms-conditions',
      PRIVACY: '/politica-privacidad',
      TERMS_DERMO:
        LANDING_BASE_URL +
        DEFAULT_LANGUAGE +
        `/terms-conditions-dermoconsejeras`,
    },
    LANDING: {
      BASE_URL: LANDING_BASE_URL,
    },
    COUNTRY: {
      ARGENTINA: 'es-AR/qr-love-isdin',
      BELGIE: 'qr-love-isdin/nl-BE',
      BELGIQUE: 'qr-love-isdin/fr-BE',
      BRASIL: 'pt-BR/qr-love-isdin',
      CHILE: 'es-CL/qr-love-isdin',
      COLOMBIA: 'es-CO/qr-love-isdin',
      DEUTSCHLAND: 'qr-love-isdin/de',
      EMIRATES: 'qr-love-isdin/en-AE',
      FRANCE: 'fr-FR/qr-love-isdin',
      ITALIA: 'it-IT/qr-love-isdin',
      MEXICO: 'es-MX/qr-love-isdin',
      PERU: 'es-PE/qr-love-isdin',
      PORTUGAL: 'pt-PT/qr-love-isdin',
      UNITEDKINGDOM: 'uk-qr-love-isdin/int',
      UNITEDSTATES: 'qr-love-isdin/en-US',
    },
  },
  BEAUTY_GUIDE: {
    BEAUTY_GUIDE_LOADER,
    BEAUTY_GUIDE_CHUNK,
    BEAUTY_GUIDE_MAIN_CHUNK,
    BEAUTY_GUIDE_CSS,
    BEAUTY_GUIDE_VERSION,
  },
};
